'use strict';

var _require = require('react'),
    useEffect = _require.useEffect;

function useDocumentTitle(title) {
  useEffect(function () {
    document.title = title;
  }, [title]);
}

module.exports = useDocumentTitle;